<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="emOpcWatchEowResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" with-custom-row-actions
                        ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                <template #customRowActions="{row}">
                  <b-button-group>
                    <em-button type="gotoGrandParent"
                               :class="'btn btn-outline-primary btn-sm'"
                               custom-label="计算属性"
                               @click="gotoGrandParentLevel(row)">
                    </em-button>
                    <em-button type="gotoChild"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               custom-label="监听条件"
                               custom-icon="fa fa-fw fa-lg fa-link"
                               @click="popEowc(row)">
                    </em-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <sub-entity-list ref="eowcEntityList" sub-entity="emOpcWatchConditionEowc"
                     parent-field="eowcIdEow"></sub-entity-list>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-06-12 15:10:21

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import subEntityList from "@/components/em/EmModal/SubEntityList";

export default {
  name: "emOpcWatchEowListView",
  mixins: [emCommonListMixin, emCommonGotoMixin],
  components:{subEntityList},
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    }
  },
  methods: {
    gotoGrandParentLevel(row) {
      this.$_emGotoMixin_gotoList("emOpcComputedEoc", row.eowIdOrigin ? row.eowIdOrigin : "",{inline:"1"})
    },
    gotoEowc(row) {
      this.$_emGotoMixin_gotoHolderList("emOpcWatchConditionEowc"
          , {eowcIdEowFilter: row.id}
          , {eowcIdEow: row.id}, true, {})
    },
    popEowc(row){
      this.$refs.eowcEntityList.showModal(row.id)
    },
  }
};
</script>